var classes = {"sliderControl":"SpUMc","sliderControlOnPhoto":"M7nQh","sliderControlDefault":"_4lvou"};

export { classes as default };
